import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, message, Result } from 'antd';
import { MailOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import api from '../services/api';

const { Title, Paragraph } = Typography;

const ForgotPassword = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await api.post('/forgot-password', { email: values.email });
      setSubmitted(true);
    } catch (error) {
      const msg = error.response?.data?.message || 'Failed to send reset link. Please try again.';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px',
          background: 'linear-gradient(135deg, #2d5a3d 0%, #3d7a4d 30%, #52b788 70%, #7fb069 100%)',
        }}
      >
        <Card
          style={{ maxWidth: 500, borderRadius: 20, boxShadow: '0 20px 60px rgba(0,0,0,0.15)' }}
        >
          <Result
            status="success"
            title="Reset Link Sent"
            subTitle="If that email is registered, a password reset link has been sent. Please check your email inbox and spam folder."
          />
          <div style={{ textAlign: 'center' }}>
            <Link to="/login">
              <Button type="primary" icon={<ArrowLeftOutlined />}>
                Back to Login
              </Button>
            </Link>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        background: 'linear-gradient(135deg, #2d5a3d 0%, #3d7a4d 30%, #52b788 70%, #7fb069 100%)',
      }}
    >
      <Card
        style={{
          width: '100%',
          maxWidth: 450,
          borderRadius: 20,
          boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Title level={2} style={{ color: '#2d5a3d', marginBottom: 8 }}>
            Forgot Password?
          </Title>
          <Paragraph style={{ color: '#6b7280' }}>
            Enter your email and we'll send you a reset link.
          </Paragraph>
        </div>
        <Form form={form} onFinish={onFinish} layout="vertical" size="large">
          <Form.Item
            name="email"
            label="Email Address"
            rules={[
              { required: true, message: 'Please enter your email!' },
              { type: 'email', message: 'Please enter a valid email!' },
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="Enter your email" />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{
                height: 48,
                borderRadius: 12,
                border: 'none',
                background: 'linear-gradient(135deg, #52b788, #3d7a4d)',
                boxShadow: '0 4px 14px rgba(82, 183, 136, 0.4)',
                fontWeight: 600,
                fontSize: 16,
              }}
            >
              Send Reset Link
            </Button>
          </Form.Item>
        </Form>
        <div style={{ textAlign: 'center' }}>
          <Link to="/login" style={{ color: '#52b788' }}>
            <ArrowLeftOutlined /> Back to Login
          </Link>
        </div>
      </Card>
    </div>
  );
};

export default ForgotPassword;
